"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbTrustedLogin = void 0;
const repository_1 = require("../../../security/authoriser/infra/repositories/checkTrustedVerificationStatus/repository");
const repository_2 = require("../../../security/authoriser/infra/repositories/trustedLoginSession/repository");
const types_1 = require("../../../security/authoriser/types");
const repository_3 = require("../../../security/authoriser/infra/repositories/repository");
const timeOut_helper_1 = require("../../../security/timeOut/helpers/timeOut.helper");
const events_1 = require("../../../security/events");
const baseTrusted_1 = require("./baseTrusted");
class VerificationError extends Error {
    constructor(source, error) {
        super('Error in Trusted Verification Status');
        this.source = source;
        this.name = 'trustedVerificationStatusError';
        this.errorData = error;
    }
}
class SessionError extends Error {
    constructor(source, error) {
        super('Error in Trusted Session Verify');
        this.source = source;
        this.name = 'trustedSessionVerifyError';
        this.errorData = error;
    }
}
class MbTrustedLogin extends baseTrusted_1.BaseTrusted {
    constructor() {
        super(...arguments);
        this.doRetry = async () => {
            try {
                const { data } = await (0, repository_3.regeneratePUSH)(this.api, this.progressId);
                this.data = { ...this.data, biometricId: data.biometricId };
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.TRUSTED_CONFIRMATION_LOGIN, success: true });
            }
            catch (_) {
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.TRUSTED_CONFIRMATION_LOGIN, success: false });
            }
        };
    }
    async doVerify() {
        this.closeAsyncConnection();
        const checkVerificationData = {
            biometricId: this.data.biometricId,
        };
        try {
            const isVerified = await repository_1.trustedVerificationStatusRepository.isVerified(this.api, this.progressId, checkVerificationData);
            if (!isVerified) {
                throw new Error('Validation from the trusted device is required');
            }
        }
        catch (error) {
            throw new VerificationError('VerificationError', error);
        }
        try {
            const session = await repository_2.trustedLoginChallengeSessionRepository.getSession(this.api, this.progressId);
            this.updateSession(session);
        }
        catch (error) {
            throw new SessionError('SessionError', error);
        }
        return {
            type: types_1.ChallengeType.NONE,
            progressId: this.progressId,
        };
    }
    updateSession(session) {
        this.session.updateData({
            ...session,
            username: this.session.getData()?.username ?? '',
            timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(session.expiresIn),
        });
    }
}
exports.MbTrustedLogin = MbTrustedLogin;
//# sourceMappingURL=trustedLogin.js.map